<template>
    <div>
        <div class="modal-avatar">
            <div class="avatar-left">
                <img  class="img" :src="redPlayer?redPlayerList[0].head:bluePlayerList[0].head" alt="">
            </div>
            <div class="avatar-middle">
                <div class="group">{{combatName}}</div>
                <div class="score" v-if="redPlayer">{{redPlayer.totalScore}} : {{bluePlayer.totalScore}}</div>
                <div class="score" v-else>{{bluePlayer.totalScore}}</div>
            </div>
            <div class="avatar-right" :class="redPlayer?'':'avatar-right-rank'">
                <img v-if="redPlayer"  class="img" :src="bluePlayerList[0].head" alt="">
                <div v-else class="ranking">
                    <span v-if="bluePlayer.rank&&bluePlayer.rank>0">第{{bluePlayer.rank&&bluePlayer.rank>0?bluePlayer.rank:''}}名</span>
                    <span v-else v-for="(rank,index) in rankList" :key="index">{{rank.num==bluePlayer.rank?rank.name:''}}</span>
                </div>
            </div> 
        </div>
        <div class="modal-line"></div>
    </div>
</template>

<script>
import AvatarList from './content/AvatarList.vue'
export default {
  name:'StreetModalAvatar',
  props:['technicalHeaderVo','combatName'],
  components:{AvatarList},
  data () {
    return {
      // rankList:负数 -1: 晋级, -2: 淘汰 -3：加赛 -4：失格  -5: 弃权 0: 暂无排名
      rankList: [
        {num:null,name:'暂无排名'},
        {num:0,name:'暂无排名'},
        {num:-1,name:'晋级'},
        {num:-2,name:'淘汰'},
        {num:-3,name:'加赛'},
        {num:-4,name:'失格'},
        {num:-5,name:'弃权'},

      ]
    }
    
  },
  methods: {
    
  },
  computed: {
    bluePlayer () {
      return this.technicalHeaderVo.bluePlayer || false
    },
    bluePlayerList () {
      return this.technicalHeaderVo.bluePlayers || []
    },
    redPlayer () {
      return this.technicalHeaderVo.redPlayer || false
    },
    redPlayerList () {
      return this.technicalHeaderVo.redPlayers || []
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-avatar{
    width: 100%;
    height: 140px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding-top: 15px;
    color: #333333;
    text-align: center;
    .avatar-left,
    .avatar-right{
        width: 300px;
        height: 100%;
            .img{
            clip: rect(0,100px);
            width: 100px;
            height: 100px;
            text-align: center;
            border-radius: 10px;
            }
            .ranking{
            width: 160px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            background-color: #2773D5;
            border-radius: 20px;
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
            }
    }
    .avatar-right-rank{
        text-align: right;
        padding-top:35px ;
    }
    .avatar-middle{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 500px;
            .group{
            color: #888888;
            font-size: 14px;
            }
            .score{
            font-size: 52px;
            font-weight: Bold;
            color: #333333;
            }
        
    }

    }
    .modal-line{
        width: 100%;
        height: 4px;
        background-color: #F6F6F6;
    }

</style>


// WEBPACK FOOTER //
// src/comm/components/modal/taekwondo/TaekwondoModalAvatar.vue